import { graphql } from 'react-relay';

export default graphql`
  query GrapefulClubPage_Query {
    viewer {
      id
      ...TheGrapefulClubPage_viewer
    }
  }
`;
